// Generated using https://github.com/workivate/AnalyticsGen
// Last update: 22/07/2025
// DO NOT EDIT

import AnalyticsSingletonFactory, { type Options } from '../common/analytics';
import type {
  AnalyticsGiftCardsPurchaseParams,
  AnalyticsCinemaPurchaseParams,
} from '../common/types';

const paramValueLength = 100;

export const AnalyticsEventsFactory = (options: Options) => {
  const Analytics = AnalyticsSingletonFactory(options);

  return {
    NewsFeed: {
      Feed: {
        Post: {
          /** When a user sends a new recognition */
          recognized: () =>
            Analytics.trackEvent('share', {
              content_type: 'Feed_Post',
              action: 'Recognized',
            }),

          /** When a user re-recognizes */
          reRecognized: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Feed_Post',
              action: 'ReRecognized',
            }),

          /** When a user sends a new post */
          created: () =>
            Analytics.trackEvent('share', {
              content_type: 'Feed_Post',
              action: 'Created',
            }),

          /** When a user reacts to a post */
          reacted: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Feed_Post',
              action: 'Reacted',
            }),

          /** When a user comments on a post */
          commented: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Feed_Post',
              action: 'Commented',
            }),
        },

        WellbeingCard: {
          /** When a user clicks on any of the wellbeing card
Report 
Id and title
Check WB -8016 */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Feed_WellbeingCard',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      Perks: {
        NewsFeed: {
          Top10Module: {
            /** When a user clicks on the Top10 news feed module

Include: 
retailer_name
offer_title */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Perks_NewsFeed_Top10Module',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          PerksArticle: {
            /** When a user clicks on the Perks Article news feed module

Include: article title */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Perks_NewsFeed_PerksArticle',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },
    },

    Work: {
      Feed: {
        Feed: {
          Search: {
            /** When a user searches the news feed

Pass the search string */
            searched: (searchTerm: string) =>
              Analytics.trackEvent('search', {
                search_location: 'Feed_Feed_Search',
                search_term: searchTerm.substring(0, paramValueLength),
              }),
          },
        },
      },
    },

    Life: {
      Eap: {
        Article: {
          NextArticle: {
            /** Each time a user Onclick read next
(include the title and content ID) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Article_NextArticle',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          DownloadPDF: {
            /** Each time the user OnClick download as pdf article (with article title and content ID) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Article_DownloadPDF',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          Print: {
            /** Each time the user OnClick print article (include the article title and content ID) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Article_Print',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          RelatedArticle: {
            /** Everytime the user OnClick a related article in an article

include the related aritlce ID and title and item position start at 1 */
            clicked: (
              itemId: string,

              itemName: string,

              itemType: string,

              itemPosition: number,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Article_RelatedArticle',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
                item_type: itemType.substring(0, paramValueLength),
                item_position: itemPosition,
              }),
          },

          /** When a user scrolls to the end of a spefic article content. To be used to track individual articles by their id */
          completed: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Article',
              action: 'Completed',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),

          /** When the user scrolls through the content of an article, an event should be sent for every 10th% of content read
(Include the article title and the content ID) */
          read: (
            percent: number,

            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('consumed_content', {
              content_type: 'EAP_Article',
              action: 'Read',
              percent: percent,
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),

          /** Everytime the user  (page/screen) views an article
(Include the article title and the content ID) */
          served: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Article',
              action: 'Served',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Category: {
          /** When a user accesses a category an event should be sent, and the event should only be sent once per navigation

Include category name and ID */
          viewed: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Category',
              action: 'Viewed',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        SubCategory: {
          /** When a user accesses a subcategory an event should be sent, and the event should only be sent once per navigation

Include category name and ID

Item type =  type.typeGroup

Item type =  type.typeGroup
FeaturedArticle
FeaturedVideo
FeaturedAudio */
          viewed: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_SubCategory',
              action: 'Viewed',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Quicklink: {
          /** When a user clicks on a specific quicklink an event should be sent once per time the user selected the quicklink

Include Quicklink name (in langage its in) and URL as the ID property, and whether its from an article or from a list, Include ID and item position start at 1

Include = UUID, Title and the Link (char lim 100)

Item type =  (partner, featured or normal link)

Item Position = the order within the list its in e.g. featured partners would be one list, featured quicklinks another

Item ID  = URL */
          clicked: (
            itemId: string,

            itemName: string,

            itemType: string,

            itemPosition: number,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Quicklink',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
              item_type: itemType.substring(0, paramValueLength),
              item_position: itemPosition,
            }),
        },

        Featured: {
          /** Each time the user clicks on an article from the featured article carousel

Include ID and title (in language its in) and carousel position start at 1 */
          clicked: (
            itemId: string,

            itemName: string,

            itemType: string,

            itemPosition: number,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Featured',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
              item_type: itemType.substring(0, paramValueLength),
              item_position: itemPosition,
            }),
        },

        Recentlyupdated: {
          /** Each time the user clicks on an article from the recently unpdated seciton

Include ID and title (in language its in)  and item position start at 1

item type = type.title

 e.g. article, toolkit, video tip etc.. */
          clicked: (
            itemId: string,

            itemName: string,

            itemType: string,

            itemPosition: number,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'EAP_Recentlyupdated',
              action: 'Clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
              item_type: itemType.substring(0, paramValueLength),
              item_position: itemPosition,
            }),
        },

        Search: {
          Searchbar: {
            /** Every time a user performs a search fire an event to capture each search term with the content the user entered */
            searched: (searchTerm: string) =>
              Analytics.trackEvent('search', {
                search_location: 'EAP_Search_Searchbar',
                search_term: searchTerm.substring(0, paramValueLength),
              }),
          },

          FilterCategory: {
            /** Each time the user selects a search filter  (category) fire an event to save the selection  */
            selected: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Search_FilterCategory',
                action: 'Selected',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          FilterType: {
            /** Each time the user selects a search filter  (Type) fire an event to save the selection  */
            selected: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Search_FilterType',
                action: 'Selected',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        Modalities: {
          GetSupport: {
            /** Every time a user OnClick a modality with an external link

Include the related type of modality  (Chat, online scheduling)"Online scheduling" =Feature keys - Online scheduling, CareNow, Support and resources,Message a Counsellor, WorkLife Services, Health Coaching) */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Modalities_GetSupport',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          GetSupportInitiate: {
            /** Every time a user OnClick a modality with an introductory step/interstitial (e.g. modal)

Include the related type of modality  (Message a counsellor) =Feature keys - Message a Counsellor) */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_Modalities_GetSupport_Initiate',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        GlobalChat: {
          Closewindow: {
            /** When a user closes the chat window with the X at the top right of the screen / modal */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_Closewindow',
                action: 'Clicked',
              }),
          },

          Minimizewindow: {
            /** When a user minimizes the chat window with the - at the top right of the screen / modal */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_Minimizewindow',
                action: 'Clicked',
              }),
          },

          Clickedstartnewchat: {
            /** When a user clicks the button 'Start new chat' after a chat has been finished */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_Clickedstartnewchat',
                action: 'Clicked',
              }),
          },

          ClickedClicktotryagain: {
            /** When a user clicks the button 'click to try again' when a message has failed to send */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_ClickedClicktotryagain',
                action: 'Clicked',
              }),
          },

          Clickonbubble: {
            /** When a user clicks on the chat bubble at the bottom right of the screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_Clickonbubble',
                action: 'Clicked',
              }),
          },

          Openwindow: {
            /** When a user opens the chat window */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'EAP_GlobalChat_Openwindow',
                action: 'Clicked',
              }),
          },
        },
      },
    },

    Wellbeing: {
      Assessments: {
        Hub: {
          NotStartedList: {
            /** When the user clicks on an assessment that the user has not started yet

Include the assessment name and assessment ID */
            started: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_Hub_NotStartedList',
                action: 'Started',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          InprogressList: {
            /** When the user clicks an assessment that the user already has in progress

Include the assessment name and assessment ID */
            selected: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_Hub_InprogressList',
                action: 'Selected',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          CompletedList: {
            /** When the user clicks an assessment that the user already has completed

Include the assessment name and assessment ID */
            selected: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_Hub_CompletedList',
                action: 'Selected',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        ScrollView: {
          /** When a user clicks exits an assessment track whether the user did not complete that particular assessment fire this event when the user leaves the assessment scroll view

include assessment ID and assessment name */
          incomplete: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Assessments_ScrollView',
              action: 'Incomplete',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),

          /** When the user answers all the questions in an assessment and then leaves

Include the assessment ID */
          completed: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Assessments_ScrollView',
              action: 'Completed',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      CareNow: {
        Programme: {
          TopBanner: {
            /** When the user clicks on the banner or the continue button  at the top of the Programme  - (Include the name of the module and ID) */
            selectedContinue: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Programme_TopBanner',
                action: 'Selected Continue',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          ModulesList: {
            /** When a user clicks on a specific module from the module list under Your Path -  (Include the name of the module and ID)

Include the state of the module - whether it is inprogress, to complete or completed. Use item type for status. */
            selectedModule: (
              itemId: string,

              itemName: string,

              itemType: string,

              itemPosition: number,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Programme_ModulesList',
                action: 'Selected Module',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
                item_type: itemType.substring(0, paramValueLength),
                item_position: itemPosition,
              }),
          },

          JoinProgramme: {
            /** Record when a user selects the Join Now button of a CareNow programme. Include Program Name and Progam ID */
            joinNowSelected: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Programme_JoinProgramme',
                action: 'Join Now Selected',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        Module: {
          Overview: {
            /** When the user starts a module, either by choosing a section heading or clicking the Start Now button
item_id = programme name
item_name = module name */
            start: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Module_Overview',
                action: 'Start',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),

            /** When the user continues a module, either by choosing a section heading or clicking the Continue button
item_id = programme name
item_name = module name */
            selectedContinue: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Module_Overview',
                action: 'Selected Continue',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),

            /** When the user restarts a module that is already completed, either by choosing a section heading or clicking the Start Now button
item_id = programme name
item_name = module name */
            restart: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Module_Overview',
                action: 'Restart',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),

            /** When the user has clicked the done button of the module irresepective of the amount of the module they have completed */
            completed: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CareNow_Module_Overview',
                action: 'Completed',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Challenge: {
        Join: {
          JoinButton: {
            /** When the user clicks on the Join button in the join challenge page  (Include the name of the challenge and ID) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Challenge_Join_JoinButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Tiering: {
        Hub: {
          HeaderInfoIcon: {
            /** When the user clicks on the  icon on the header in the tiering hub activity view (the same event for the icon in the header and the page) */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_HeaderInfoIcon',
                action: 'Clicked',
              }),
          },

          ActivityNotStarted: {
            /** When the user clicks on the activity in the To Start in the Tiering Hub

Include activity name and the ID */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_ActivityNotStarted',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          StartAssessment: {
            /** When the user selects start assessment from the tiering list  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_StartAssessment',
                action: 'Clicked',
              }),
          },

          JoinChallenge: {
            /** When the user selects joinchallenge from the tiering list  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_JoinChallenge',
                action: 'Clicked',
              }),
          },

          ReadSnackable: {
            /** When the user selects read snackable from the tiering list  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_ReadSnackable',
                action: 'Clicked',
              }),
          },

          HistoryTab: {
            /** When the user clicks on history tab from the tiering hub  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_HistoryTab',
                action: 'Clicked',
              }),
          },

          RegressionCard: {
            /** When the user clicks on tell me more from the regression page upon  fallin into regression */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Hub_RegressionCard',
                action: 'Clicked',
              }),
          },
        },

        Feedback: {
          DoneButton: {
            /** When the user clicks on the Done button in the Custom Activities modal (Include name and ID) */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Feedback_DoneButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          NextActivity: {
            /** When the user clicks on the next activity from the feedback screen
Report ID and title of the activity */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Tiering_Feedback_NextActivity',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Rewards: {
        Hub: {
          RewardsCard: {
            /** When the user selects the rewards from the rewards hub
Report Id and title of the eward, position and (type as "Rewards" hardcoded string) */
            clicked: (
              itemId: string,

              itemName: string,

              itemType: string,

              itemPosition: number,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Rewards_Hub_RewardsCard',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
                item_type: itemType.substring(0, paramValueLength),
                item_position: itemPosition,
              }),
          },
        },

        RewardsOverview: {
          VisitWebsite: {
            /** When the user clicks on the visit website button from the reward overview page
Report the ID and the name
Make sure that the event is firing for wellbeing rewards only
 */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Rewards_RewardsOverview_VisitWebsite',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },
    },

    Perks: {
      ExclusiveOffers: {
        Details: {
          GetDeal: {
            /** When the user clicks on Get Deal button for an Exclusive Offer from the Exclusie Offer detail page.

Inclue ID of the deal and retailer name. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'ExclusiveOffers_Details_GetDeal',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Top10: {
        Details: {
          GetDeal: {
            /** When the user clicks Get Deal button for a Top 10 offer from the Top 10 detail page.

Include the ID of the deal and the retailer name. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Top10_Details_GetDeal',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Cashback: {
        Details: {
          GetCashback: {
            /** When the user clicks any Get Cashback button for a Cashback offer from the Cashback merchant detail page.

Include the ID and the name of the retailer. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Cashback_Details_GetCashback',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          GetOffer: {
            /** When the user clicks any Get Deal button for a Cashback offer from the Cashback merchant detail page.

Include the ID and the name of the retailer. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Cashback_Details_GetOffer',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      GiftCard: {
        Checkout: {
          ConfirmPayment: {
            /** When the user clicks Confirm Payment button for a Gift Card from the Gift Card checkout page.

Include the value, ID, and name of the gift card. */
            clicked: (giftCardPurchase: AnalyticsGiftCardsPurchaseParams) =>
              Analytics.trackEvent('purchase', {
                ...giftCardPurchase,
              }),
          },
        },
      },

      Cinema: {
        Checkout: {
          ConfirmPayment: {
            /** When the user clicks Confirm Payment button for a Cinema code from the Cinema checkout page.

Include the value of the transaction, number of tickets of each ticket type, ID and name of the Cinema chain. */
            clicked: (cinemaPurchase: AnalyticsCinemaPurchaseParams) =>
              Analytics.trackEvent('purchase', {
                ...cinemaPurchase,
              }),
          },
        },
      },

      Carousel: {
        Banner: {
          /** When the user click on a Banner image in the Carousel.

Include the ID of the banner */
          selected: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Carousel_Banner',
              action: 'Selected',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      Search: {
        Search: {
          /** When the user searches the perks section using the global search

Include the search term */
          searched: (searchTerm: string) =>
            Analytics.trackEvent('search', {
              search_location: 'Search_Search',
              search_term: searchTerm.substring(0, paramValueLength),
            }),
        },
      },

      Newsletter: {
        Walkthrough: {
          OptOutOfNewsletter: {
            /** When the user chooses to opt out of receiving the Perks Newsletter while going through the walkthrough screens */
            selected: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Newsletter_Walkthrough_OptOutOfNewsletter',
                action: 'Selected',
              }),
          },
        },
      },
    },

    Tmh: {
      CarePlanOnboarding: {
        LeaveButton: {
          /** When the user clicks "Leave" on the exit alert during Care Plan onboarding */
          exited: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'CarePlanOnboarding_LeaveButton',
              action: 'Exited',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        CounsellingQuestion: {
          ContinueButton: {
            /** When a user clicks continue button. The ID or name field should be the option selected. "self-care" or "counselling". */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_CounsellingQuestion_ContinueButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        CounsellingIntro: {
          ContinueButton: {
            /** When a user submits their answers to an assessment */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_CounsellingIntro_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        CareIssues: {
          SelectCareIssue: {
            /** When the user selects a care issue on the care issue selection screen */
            selected: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlanOnboarding_CareIssues_SelectCareIssue',
                action: 'Selected',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          NotSureButton: {
            /** When a user clicks the "Not sure where to start?" button on the care issue selection screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlanOnboarding_CareIssues_NotSureButton',
                action: 'Clicked',
              }),
          },

          SomethingElseButton: {
            /** When a user clicks the "Want to work on something else?" button on the care issue selection screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_CareIssues_SomethingElseButton',
                action: 'Clicked',
              }),
          },

          StartWithDefaultButton: {
            /** When a user clicks the "Start with X (default care plan)" button on the Not Sure screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_CareIssues_StartWithDefaultButton',
                action: 'Clicked',
              }),
          },
        },

        Assessments: {
          SubmitButton: {
            /** When a user submits their answers to an assessment */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlanOnboarding_Assessments_SubmitButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        ImmediateHelp: {
          AcceptButton: {
            /** When a user clicks the "I need immediate help" button on the "Immediate Help" screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlanOnboarding_ImmediateHelp_AcceptButton',
                action: 'Clicked',
              }),
          },

          PhoneNumberButton: {
            /** When a user clicks the call button on either the Immediate Help or Contact Us screen. The route is included so that we can see where this occurs. */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_ImmediateHelp_PhoneNumberButton',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        CounsellingNextSteps: {
          GoToMyCareButton: {
            /** When the user clicks "Go To My Care" button on the "Next Steps" screen at the end of the onboarding flow */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'CarePlanOnboarding_CounsellingNextSteps_GoToMyCareButton',
                action: 'Clicked',
              }),
          },
        },
      },

      RetakingAssessments: {
        Assessments: {
          SubmitButton: {
            /** When a user clicks continue on the "How would you like to work" screen */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'RetakingAssessments_Assessments_SubmitButton',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          LeaveButton: {
            /** When the user clicks the "Leave" button when exiting the retake flow, ID is the page that they are on */
            exited: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'RetakingAssessments_Assessments_LeaveButton',
                action: 'Exited',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          ContinueButton: {
            /** When the user clicks the "Continue" button on the "How've you been lately?" screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'RetakingAssessments_Assessments_ContinueButton',
                action: 'Clicked',
              }),
          },
        },
      },

      MyCare: {
        WorkLifeServices: {
          FindOutMoreButton: {
            /** When a user clicks "Find out more" on the Work Life Services card */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_WorkLifeServices_FindOutMoreButton',
                action: 'Clicked',
              }),
          },

          ClickCategory: {
            /** When a user clicks a category on the Work Life Services page. The category name is included. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_WorkLifeServices_ClickCategory',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          ChatToUsButton: {
            /** When a user clicks "Chat with us" on the Work Life Services page */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_WorkLifeServices_ChatToUsButton',
                action: 'Clicked',
              }),
          },
        },

        AssessmentHistory: {
          OpenButton: {
            /** When the user clicks the button to open the assessments area and view their scores */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_AssessmentHistory_OpenButton',
                action: 'Clicked',
              }),
          },

          RetakeButton: {
            /** When a user clicks the "Retake assessments" button on the assessment score screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_AssessmentHistory_RetakeButton',
                action: 'Clicked',
              }),
          },

          RetakeSingleButton: {
            /** When the user clicks the button to retake a single assessment on the Assessment Score screen. The item_id is for the assessment. The item_name is for the assessment. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_AssessmentHistory_RetakeSingleButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          ViewHistoryButton: {
            /** When the user clicks the View History button to see previous assessment scores. The item_id is for the assessment. The item_name is for the assessment. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_AssessmentHistory_ViewHistoryButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        ChatCard: {
          StartChatButton: {
            /** When a user clicks the "Start a chat" button on the Chat card on My Care */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'MyCare_ChatCard_StartChatButton',
                action: 'Clicked',
              }),
          },
        },
      },

      CarePlan: {
        MyCare: {
          ContinueButton: {
            /** When the user clicks the  "Continue" button on the My Care home page for their Care Plan */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_MyCare_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        ContentOverview: {
          Activity: {
            /** When the user clicks on an activity from the "Content Overview" for the Care Plan */
            clicked: (
              itemId: string,

              itemName: string,

              itemType: string,

              itemPosition: number,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_ContentOverview_Activity',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
                item_type: itemType.substring(0, paramValueLength),
                item_position: itemPosition,
              }),
          },
        },

        Activity: {
          MarkAsCompleteButton: {
            /** When the user clicks "Mark as complete" on an activity for the Care Plan */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_Activity_MarkAsCompleteButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        ChangeCarePlan: {
          SubmitButton: {
            /** When a user clicks "Change care plan" button on the Change Care Plan screen. The name of the new Care Plan is included. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_ChangeCarePlan_SubmitButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        Article: {
          DownloadPDF: {
            /** When a user clicks to download a PDF on an article. The name of the article is included. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_Article_DownloadPDF',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          TexttoSpeech: {
            /** When a user clicks to listen (text to speech) to an article that is NOT an audio type.  Item ID is the article ID.  */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_Article_TexttoSpeech',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        NextSteps: {
          GoToMyCareButton: {
            /** When a user clicks "Go to My Care" on the Care Plan Complete screen.  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_NextSteps_GoToMyCareButton',
                action: 'Clicked',
              }),
          },
        },

        Introduction: {
          ContinueButton: {
            /** When a user clicks "Continue" on the Care Plan intro screen.  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'CarePlan_Introduction_ContinueButton',
                action: 'Clicked',
              }),
          },
        },
      },

      Assessments: {
        MyCare: {
          LetsGoButton: {
            /** When the user clicks the  "Let's Go" button on the My Care home page to begin assessments flow */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_MyCare_LetsGoButton',
                action: 'Clicked',
              }),
          },

          ContinueButton: {
            /** When the user clicks the  "Continue" button on the My Care home page to resume assessments flow */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_MyCare_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        AssessmentScores: {
          ContinueButton: {
            /** When the user clicks the  "Continue" button on the Assessment Scores screen  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_AssessmentScores_ContinueButton',
                action: 'Clicked',
              }),
          },

          AreYouSureContinueButton: {
            /** When the user clicks the  "Continue" button on the warning for retaking an assessment from the Assessment Results screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Assessments_AssessmentScores_AreYouSureContinueButton',
                action: 'Clicked',
              }),
          },

          AreYouSureBackButton: {
            /** When the user clicks the  "Back" button on the warning for retaking an assessment from the Assessment Results screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Assessments_AssessmentScores_AreYouSureBackButton',
                action: 'Clicked',
              }),
          },
        },

        WhatsNext: {
          StartCarePlanButton: {
            /** When the user clicks the  "Start Care Plan" button on the What's Next screen  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_WhatsNext_StartCarePlanButton',
                action: 'Clicked',
              }),
          },

          GoToMyCareButton: {
            /** When the user clicks the  "Go To My Care" button on the What's Next screen  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_WhatsNext_GoToMyCareButton',
                action: 'Clicked',
              }),
          },
        },

        ImmediateHelp: {
          CallMeButton: {
            /** When the user clicks the  "Call Me" on the Contact Number screen  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_ImmediateHelp_CallMeButton',
                action: 'Clicked',
              }),
          },

          LeavePhoneNumber: {
            /** When the user clicks the  "Leave my phone number" on the Let's Talk screen  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_ImmediateHelp_LeavePhoneNumber',
                action: 'Clicked',
              }),
          },
        },

        UnderAgeDisclaimer: {
          BacktoMyCareButton: {
            /** When the user clicks the  "Back to My Care" on the Under Age screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Assessments_UnderAgeDisclaimer_BacktoMyCareButton',
                action: 'Clicked',
              }),
          },

          Over18Button: {
            /** When the user clicks the  "Over 18" on the Under Age screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Assessments_UnderAgeDisclaimer_Over18Button',
                action: 'Clicked',
              }),
          },
        },
      },

      Mood: {
        MyCare: {
          Emoji: {
            /** When a user clicks Emoji on the Mood card on My Care. The id would be the emoji. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_MyCare_Emoji',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          ViewAll: {
            /** When a user clicks "View All" on the Mood card on My Care to see their mood history */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_MyCare_ViewAll',
                action: 'Clicked',
              }),
          },
        },

        NewEntry: {
          Factor: {
            /** When a user chooses factors for their mood entry on the New Entry screen. The IDs will be the factor names. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_NewEntry_Factor',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          SaveButton: {
            /** When a user saves their mood entry on the New Entry screen. The IDs will be the emoji. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_NewEntry_SaveButton',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },

        EditEntry: {
          Factor: {
            /** When a user "Edit" for a given mood entry on the New Entry screen. The IDs will be the factor names. */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_EditEntry_Factor',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          SaveButton: {
            /** When a user edits their mood entry and clicks save */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_EditEntry_SaveButton',
                action: 'Clicked',
              }),
          },
        },

        CustomFactors: {
          Delete: {
            /** When a user clicks to delete a custom factor on the Custom Factor page */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_CustomFactors_Delete',
                action: 'Clicked',
              }),
          },
        },

        History: {
          DateRange: {
            /** When a user clicks a date range on the mood insights section  */
            clicked: (
              itemId: string,

              itemName: string,
            ) =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_History_DateRange',
                action: 'Clicked',
                item_id: itemId.substring(0, paramValueLength),
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          InsightsTab: {
            /** When a user clicks the Insights tab on the Mood History view */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_History_InsightsTab',
                action: 'Clicked',
              }),
          },

          ChartNavigation: {
            /** When a user clicks to navigate back and forth between dates in mood insights section  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_History_ChartNavigation',
                action: 'Clicked',
              }),
          },

          TrackMood: {
            /** When a user clicks to track mood from the mood insights section on the empty state  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Mood_History_TrackMood',
                action: 'Clicked',
              }),
          },
        },
      },

      Journal: {
        NewEntry: {
          SaveButton: {
            /** When a user clicks the Save button on a new journal entry */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Journal_NewEntry_SaveButton',
                action: 'Clicked',
              }),
          },
        },

        EditEntry: {
          SaveButton: {
            /** When a user clicks the Save button and an existing entry */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Journal_EditEntry_SaveButton',
                action: 'Clicked',
              }),
          },
        },

        History: {
          Delete: {
            /** When the user clicks the Delete button on the journal history  */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Journal_History_Delete',
                action: 'Clicked',
              }),
          },
        },
      },

      Appointments: {
        MyCare: {
          ChooseCounsellor: {
            /** When a user clicks choose a counsellor on the My care homepage */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_MyCare_ChooseCounsellor',
                action: 'Clicked',
              }),
          },

          ChangeCounsellor: {
            /** When a user clicks Change on the My Care homepage */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_MyCare_ChangeCounsellor',
                action: 'Clicked',
              }),
          },

          StartChat: {
            /** When a user clicks Start Chat on the appointments card on My Care homepage */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_MyCare_StartChat',
                action: 'Clicked',
              }),
          },
        },

        Introtocounselling: {
          Messageus: {
            /** When a user clicks Message us on the Intro to counselling screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_Introtocounselling_Messageus',
                action: 'Clicked',
              }),
          },
        },

        Whereareyoulocated: {
          ContinueButton: {
            /** When a user selects a region and clicks Continue on the Where are you located screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_Whereareyoulocated_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        CounsellorProfile: {
          ChooseCounsellor: {
            /** When a user selects Choose Counsellor on the Counsellor Profile */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_CounsellorProfile_ChooseCounsellor',
                action: 'Clicked',
              }),
          },

          CheckAvailability: {
            /** When a user clicks Check Availability on the Counsellors Profile screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Appointments_CounsellorProfile_CheckAvailability',
                action: 'Clicked',
              }),
          },

          MessageUs: {
            /** WHen a user clicks message us on the counsellor profile screen of a provider with no calendar in Dynamics (offline provider) */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_CounsellorProfile_MessageUs',
                action: 'Clicked',
              }),
          },

          ChangeCounsellor: {
            /** When a user clicks Change counsellor on the counsellor profile screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_CounsellorProfile_ChangeCounsellor',
                action: 'Clicked',
              }),
          },
        },

        YourCounsellor: {
          ViewAvailability: {
            /** When a user clicks View Availability on the Your Counsellor screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_YourCounsellor_ViewAvailability',
                action: 'Clicked',
              }),
          },

          GoToMyCareButton: {
            /** When a user clicks Go To My Care on the Your Counsellor screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_YourCounsellor_GoToMyCareButton',
                action: 'Clicked',
              }),
          },
        },

        YourContactDetails: {
          BookAppointmentButton: {
            /** When a user clicks Book Appointment on the Your Contact Details screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Appointments_YourContactDetails_BookAppointmentButton',
                action: 'Clicked',
              }),
          },

          ContinueButton: {
            /** When a user clicks Book Appointment on the Your Contact Details screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_YourContactDetails_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        AppointmentDetail: {
          AddToMyCalendar: {
            /** When a user clicks Add To My Calendar on the Appointment Confirmed screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_AppointmentDetail_AddToMyCalendar',
                action: 'Clicked',
              }),
          },

          ViewProfile: {
            /** When a user clicks View Profile on the Appointment Confirmed screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_AppointmentDetail_ViewProfile',
                action: 'Clicked',
              }),
          },

          CancelAppointment: {
            /** When a user clicks Cancel Appointment on the Appointment Confirmed screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Appointments_AppointmentDetail_CancelAppointment',
                action: 'Clicked',
              }),
          },
        },

        AppointmentConfirmed: {
          DoneButton: {
            /** When a user clicks Done on the Appointment Confirmed screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_AppointmentConfirmed_DoneButton',
                action: 'Clicked',
              }),
          },
        },

        YourAppointments: {
          BookAnAppointment: {
            /** When a user clicks Book An Appointment on the Your Appointments screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_YourAppointments_BookAnAppointment',
                action: 'Clicked',
              }),
          },
        },

        Chooseacounsellor: {
          Messageus: {
            /** When a user clicks Message us on the Choose a Counsellor  screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_Chooseacounsellor_Messageus',
                action: 'Clicked',
              }),
          },
        },

        Nocounsellorsavailable: {
          Messageus: {
            /** When a user clicks Message us on the No counsellors available screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_Nocounsellorsavailable_Messageus',
                action: 'Clicked',
              }),
          },
        },

        ChangeCounsellorModal: {
          ContinueButton: {
            /** When a user clicks Continue on the Change Counsellor Modal */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type:
                  'Appointments_ChangeCounsellorModal_ContinueButton',
                action: 'Clicked',
              }),
          },

          MessageUs: {
            /** When user clicks Message Us on the change counsellor modal */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_ChangeCounsellorModal_MessageUs',
                action: 'Clicked',
              }),
          },
        },

        PaymentDisclaimer: {
          ContinueButton: {
            /** When a user clicks "continue" on the Payment Disclaimer at the beginning of the flow */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_PaymentDisclaimer_ContinueButton',
                action: 'Clicked',
              }),
          },
        },

        SetUpPayment: {
          Button: {
            /** When a user clicks the "Add payment details" button on the "Payment details" screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_SetUpPayment_Button',
                action: 'Clicked',
              }),
          },

          ChangeButton: {
            /** When a user clicks the "Add payment details" button on the "Payment details" screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_SetUpPayment_ChangeButton',
                action: 'Clicked',
              }),
          },

          BookAppointmentButton: {
            /** When the confirmation of payment is received from Stripe and the user lands on the "Appointment confirmed" screen */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_SetUpPayment_BookAppointmentButton',
                action: 'Clicked',
              }),
          },
        },

        CancellationDisclaimer: {
          OkayButton: {
            /** When a user clicks the "Okay" button on the cancellation disclaimer */
            clicked: () =>
              Analytics.trackEvent('select_content', {
                content_type: 'Appointments_CancellationDisclaimer_OkayButton',
                action: 'Clicked',
              }),
          },
        },
      },
    },

    Session: {
      Experiment: {
        /** When a user is assigned to an experiment */
        assigned: (
          eventCategory: string,

          experimentId: string,

          variationId: string,
        ) =>
          Analytics.trackEvent('experiment_viewed', {
            content_type: 'Experiment',
            action: 'Assigned',
            event_category: eventCategory.substring(0, paramValueLength),
            experiment_id: experimentId.substring(0, paramValueLength),
            variation_id: variationId.substring(0, paramValueLength),
          }),
      },
    },

    Integrations: {
      Thvc: {
        NewsFeed: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_NewsFeed',
              action: 'Clicked',
            }),
        },

        Menu: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_Menu',
              action: 'Clicked',
            }),
        },

        MyCare: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_MyCare',
              action: 'Clicked',
            }),
        },

        SupportandResources: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_SupportandResources',
              action: 'Clicked',
            }),
        },

        Services: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_Services',
              action: 'Clicked',
            }),
        },

        Modalities: {
          /** When a member clicks the THVC integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THVC_Modalities',
              action: 'Clicked',
            }),
        },

        Interstitial: {
          OpenTHVC: {
            /** When a member clicks out to THVC from the interstitial page

Include the page where the interstitial was opened from */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'THVC_Interstitial_OpenTHVC',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          THVCSignUp: {
            /** When a member clicks on the sign up button on the interstitial page

Include the page where the interstitial was opened from */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'THVC_Interstitial_THVCSignUp',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },

      Thwb: {
        NewsFeed: {
          /** When a member clicks the THWB integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THWB_NewsFeed',
              action: 'Clicked',
            }),
        },

        Menu: {
          /** When a member clicks the THWB integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THWB_Menu',
              action: 'Clicked',
            }),
        },

        Wellbeing: {
          /** When a member clicks the THWB integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THWB_Wellbeing',
              action: 'Clicked',
            }),
        },

        SupportandResources: {
          /** When a member clicks the THWB integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THWB_SupportandResources',
              action: 'Clicked',
            }),
        },

        Services: {
          /** When a member clicks the THWB integration CTA */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'THWB_Services',
              action: 'Clicked',
            }),
        },

        Interstitial: {
          OpenTHWB: {
            /** "When a member clicks out to THWB from the interstitial page

Include the page where the interstitial was opened from" */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'THWB_Interstitial_OpenTHWB',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },

          THWBSignUp: {
            /** When a member clicks out to THWB from the interstitial page

Include the page where the interstitial was opened from */
            clicked: (itemName: string) =>
              Analytics.trackEvent('select_content', {
                content_type: 'THWB_Interstitial_THWBSignUp',
                action: 'Clicked',
                item_name: itemName.substring(0, paramValueLength),
              }),
          },
        },
      },
    },

    Home: {
      Home: {
        Search: {
          /** When a member opens search from home */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Home_Search',
              action: 'Clicked',
            }),
        },

        Modalities: {
          /** When a member clicks on the connect with us button opens the modalities screen */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'Home_Modalities',
              action: 'clicked',
            }),
        },

        FeaturedService: {
          /** When a member clicks on a featured service, include service name (analytics ID) */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Home_FeaturedService',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      Services: {
        Services: {
          /** When a member clicks on a service, include service name (analytics ID) */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Services_Services',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        Partner: {
          /** When a member clicks on a partner include partner name (Quick link name) */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'Services_Partner',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      CareTopicsOnboarding: {
        CareTopicSelection: {
          /** When a member clicks on wellbeing interests / areas they would like to focus on during onboarding */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'CareTopicsOnboarding_CareTopicSelection',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        FocusSelection: {
          /** When a member clicks on focus areas they would like to work on during onboarding */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'CareTopicsOnboarding_FocusSelection',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        GetStarted: {
          /** When a member the get started button to capture their interests from on the home page because they either skipped onboarding or have no existing CareNow programs selected */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'CareTopicsOnboarding_GetStarted',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },
      },

      RecommendedCareNowProgram: {
        StartNow: {
          /** When a member clicks start now to begin their recommended Care Now program */
          clicked: (
            itemId: string,

            itemName: string,
          ) =>
            Analytics.trackEvent('select_content', {
              content_type: 'RecommendedCareNowProgram_StartNow',
              action: 'clicked',
              item_id: itemId.substring(0, paramValueLength),
              item_name: itemName.substring(0, paramValueLength),
            }),
        },

        SuggestSomethingElse: {
          /** When a member clicks Suggest something else to see other recommended Care Now programs */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'RecommendedCareNowProgram_SuggestSomethingElse',
              action: 'clicked',
            }),
        },

        ChangeYourInterests: {
          /** When a member clicks the Change your interests button to re-select their chosen care topics  */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'RecommendedCareNowProgram_ChangeYourInterests',
              action: 'clicked',
            }),
        },

        MoreRecommendations: {
          /** When a member clicks more recommendations button to pick up where they left off choosing their care topics */
          clicked: () =>
            Analytics.trackEvent('select_content', {
              content_type: 'RecommendedCareNowProgram_MoreRecommendations',
              action: 'clicked',
            }),
        },
      },
    },

    App: {
      IconShortcut: {
        /** When a user taps on an App Icon Shortcut on iOS and Android. IDs are the shortcut ids. Name should be an empty string. */
        clicked: (
          itemId: string,

          itemName: string,
        ) =>
          Analytics.trackEvent('select_content', {
            content_type: 'IconShortcut',
            action: 'clicked',
            item_id: itemId.substring(0, paramValueLength),
            item_name: itemName.substring(0, paramValueLength),
          }),
      },
    },
  };
};
